<ng-template let-item #playlist>
  <div class="search-result">
    <mwo-smart-cover [item]="item" [coverTitle]="item.name" [isSearchPage]="true" (click)="handleCardClick('playlists', item.id)"></mwo-smart-cover>
    <div class="playlist-information">
      <p class="type">PLAYLIST</p>
      <h3 class="title">{{ item.name }}</h3>
      <p class="subtitle">{{ item.duration | duration:'hh:mm' }}</p>
    </div>
  </div>
</ng-template>

<ng-template let-item #artist>
  <div class="search-result">
    <img class="cover" [src]="item.coverUrl || 'assets/icons/default_icon.webp'" alt="{{ item.name }}">
    <h3 class="title infos">{{ item.name }}</h3>
  </div>
</ng-template>

<ng-template let-item #track>
  <div class="search-result">
    <img class="cover" [src]="getCoverUrl(item.id)" alt="{{ item.name }}">
    <div class="infos">
      <h3 class="title">{{ item.title }}</h3>
      <p class="subtitle">{{ item.artist.name }}</p>
    </div>
  </div>
</ng-template>

<div class="search-container">
  <h1>{{ 'search.title' | translate }}</h1>

  <mwo-search-bar [placeholder]="'search.placeholders.input'" (onSearchInput)="handleSearch($event)" (onEmptyValue)="handleEmptyValue()"></mwo-search-bar>

  <div class="search-results" *ngIf="showResults">
    <mwo-smart-grid [mode]="'horizontal'" [list]="playlists$" [itemTpl]="playlist" [fullPage]="false" [isSearchPage]="true">
      <h3 header>{{ 'search.results.playlists' | translate }}</h3>
    </mwo-smart-grid>
    <mwo-smart-grid [mode]="'horizontal'" [list]="artists$" [itemTpl]="artist" [fullPage]="false" [isSearchPage]="true">
      <h3 header>{{ 'search.results.artists' | translate }}</h3>
    </mwo-smart-grid>
    <mwo-smart-grid [mode]="'horizontal'" [list]="tracks$" [itemTpl]="track" [fullPage]="false" [isSearchPage]="true">
      <h3 header>{{ 'search.results.tracks' | translate }}</h3>
    </mwo-smart-grid>
  </div>
  <div class="no-search dimmed" *ngIf="!showResults && !showNotFound">
    <img class="search-icon" src="/assets/icons/search.svg" alt="search-icon"/>
    <h3 class="title">{{ 'search.placeholders.title' | translate }}</h3>
    <p class="subtitle">{{ 'search.placeholders.subTitle' | translate }}</p>
  </div>
  <div class="no-results" *ngIf="showNotFound">
    <img src="/assets/icons/binocular.svg" alt="not found"/>
    <div class="dimmed">
      <h3 class="title">{{ 'search.notFound.title' | translate }}</h3>
      <h3 class="subtitle">{{ 'search.notFound.subtitle' | translate }}</h3>
    </div>
    <button class="rounded-button request">
      {{ 'search.notFound.demand' | translate }}
    </button>
  </div>
</div>
